import { Box, Skeleton, SkeletonText } from "@chakra-ui/react"

function PropertyCardSkeleton() {
  return (
    <>
      {/* Skeleton for Image */}
      <Skeleton height='185.98px' width='317.7px' borderRadius='14px' />

      <Box flexGrow={1} textAlign='left' mt='5px'>
        {/* Title Skeleton */}
        <SkeletonText
          noOfLines={2}
          width='95%'
          skeletonHeight='14px'
          spacing={1}
        />
        {/* Location Skeleton */}
        <Skeleton height='14px' width='40%' mt='7px' />
      </Box>

      <Box display={{ sm: "flex" }} justifyContent='space-between' mt='13.58px'>
        {/* Property Features Skeleton */}
        <Skeleton height='18px' width='30%' />
        <Skeleton height='18px' width='30%' />
        <Skeleton height='18px' width='30%' />
      </Box>
    </>
  )
}

export default PropertyCardSkeleton
